export const BRAND = {
    name: "İstanbul Dövme Silme",
    owner: "Doğuş Çizikoğlu",
    phone: "+905359156506",
    phoneDigits: "905359156506",
    address:
        "Güzelyurt Mahallesi, Yıldırım Beyazıt Caddesi No:17, Botanica İstanbul Sitesi Dükkan 25, Esenyurt / İstanbul",
    addressShort: "Esenyurt / İstanbul",
    mapsQuery:
        "Botanica İstanbul Sitesi, Güzelyurt Mahallesi Yıldırım Beyazıt Caddesi No:17, Esenyurt İstanbul",
};

export const WHATSAPP_URL = `https://wa.me/${BRAND.phoneDigits}?text=${encodeURIComponent(
    "Merhaba, İstanbul Dövme Silme sitesinden ulaşıyorum. Dövme silme veya lazer iz uygulamaları için ön değerlendirme almak istiyorum.",
)}`;

export const TEL_URL = `tel:${BRAND.phone}`;
export const MAPS_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(BRAND.mapsQuery)}`;

export const HERO_IMAGE =
    "https://customer-assets.emergentagent.com/job_pico-tattoo-removal/artifacts/cwb1ikzn_80889F0B-B692-4A88-BD25-DB63299C8850.PNG";

export const IMAGES = {
    heroBg: "https://static.prod-images.emergentagent.com/jobs/6652bdda-ec94-46a5-ab7b-b7cda47c138b/images/8d09b837d0f5dd4c5414bc35bbbf6ff92ad3ada718723689461a3454a89d0525.png",
    clinicInterior:
        "https://static.prod-images.emergentagent.com/jobs/6652bdda-ec94-46a5-ab7b-b7cda47c138b/images/538b904b06070ee033e9c86950990bbb8468d3ac580e2daf29fb1f656068a756.png",
    skinTexture:
        "https://static.prod-images.emergentagent.com/jobs/6652bdda-ec94-46a5-ab7b-b7cda47c138b/images/33c7f818821061e5ee1d062deeda5c4925666647736df8538e335bf8c376a754.png",
    metallic:
        "https://static.prod-images.emergentagent.com/jobs/6652bdda-ec94-46a5-ab7b-b7cda47c138b/images/eb42876b88e804dfbb00e4c17f6987593b94b1bce0b95b9538c8289db26c87cd.png",
    treatment1:
        "https://images.pexels.com/photos/7363189/pexels-photo-7363189.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    treatment2:
        "https://images.pexels.com/photos/4586726/pexels-photo-4586726.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    dermatology:
        "https://images.pexels.com/photos/4046564/pexels-photo-4046564.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const SERVICES = [
    {
        slug: "pico-lazer-dovme-silme",
        title: "Pico Lazer Dövme Silme",
        short: "Pico saniye atımlı lazer ile dövme pigmenti parçalama yaklaşımı.",
        icon: "Sparkles",
        keywords: "İstanbul Pico lazer dövme silme, lazerle dövme silme",
        intro:
            "Pico lazer, kısa atımlı yapısı sayesinde dövme pigmentini parçalamaya yönelik geliştirilmiş bir lazer teknolojisidir. Seans sayısı; cilt yapısı, dövme rengi, derinliği ve yaşı gibi faktörlere göre kişisel olarak planlanır.",
        bullets: [
            "Renkli ve siyah dövmelerde değerlendirme",
            "Cover-up öncesi açtırma planlaması",
            "Cilt analizi sonrası seans aralıkları belirlenir",
        ],
        image: "treatment1",
    },
    {
        slug: "cover-up-oncesi-dovme-actirma",
        title: "Cover-up Öncesi Dövme Açtırma",
        short: "Yeni dövme tasarımı öncesi mevcut dövmenin tonunu açma süreci.",
        icon: "Layers",
        keywords: "cover-up öncesi dövme açtırma İstanbul",
        intro:
            "Yeni dövme tasarımının üzerine kapatılacağı bölgenin tonunu açmaya yönelik planlamadır. Tam silme yerine açma hedeflendiğinden seans sayısı genellikle daha azdır. Plan kişisel değerlendirme sonrası belirlenir.",
        bullets: [
            "Yeni dövme tasarımı için altyapı",
            "Kontrollü ton açma yaklaşımı",
            "Dövme sanatçısı ile uyumlu süreç",
        ],
        image: "treatment2",
    },
    {
        slug: "fraksiyonel-co2-lazer",
        title: "Fraksiyonel CO2 Lazer",
        short: "Cilt yüzeyinde mikro alanlarla yenilenme sürecini destekleme.",
        icon: "Waves",
        keywords: "Fraksiyonel CO2 lazer İstanbul, akne izi cilt yenileme",
        intro:
            "Fraksiyonel CO2 lazer, cilt yüzeyinde mikro alanlar oluşturarak yenilenme sürecini desteklemeye yönelik bir teknolojidir. Akne izi, ameliyat izi, yanık izi ve cilt yüzeyindeki düzensizlik görünümünün azaltılmasına yönelik değerlendirme yapılır.",
        bullets: [
            "Akne izi görünümünün azaltılmasına yönelik",
            "Cilt yüzeyi pürüzlülüğü değerlendirmesi",
            "Kişiye özel yoğunluk planlaması",
        ],
        image: "dermatology",
    },
    {
        slug: "faca-izi-tedavisi",
        title: "Faça İzi Görünümünü Azaltma",
        short: "Faça izi görünümünün lazer ile değerlendirilmesi.",
        icon: "Activity",
        keywords: "faça izi tedavisi İstanbul",
        intro:
            "Faça izi görünümünün azaltılmasına yönelik lazer uygulamaları kişisel değerlendirme sonrası planlanır. Sonuçlar cilt yapısı ve izin yaşına göre değişebilir.",
        bullets: [
            "Kişisel iz analizi",
            "Çok seanslı planlama",
            "Cilt iyileşme sürecine göre takip",
        ],
        image: "skinTexture",
    },
    {
        slug: "yanik-izi-tedavisi",
        title: "Yanık İzi Görünümünü Azaltma",
        short: "Yanık izi görünümüne yönelik lazer değerlendirme süreci.",
        icon: "Flame",
        keywords: "yanık izi tedavisi İstanbul",
        intro:
            "Yanık izi görünümünün azaltılmasına yönelik kişisel değerlendirme; izin derinliği, yaşı ve cilt yapısına göre planlanır. Sonuçlar kişiden kişiye değişebilir.",
        bullets: [
            "İzin yaşı ve derinliği analizi",
            "Bölgesel planlama",
            "Cilt bakım yönergeleri",
        ],
        image: "dermatology",
    },
    {
        slug: "akne-izi-tedavisi",
        title: "Akne İzi & Cilt Yenileme",
        short: "Akne izi görünümü ve cilt yenileme yaklaşımları.",
        icon: "Sun",
        keywords: "akne izi lazer tedavisi İstanbul",
        intro:
            "Akne izi görünümünün azaltılmasına ve cilt yüzeyi yenilenmesine yönelik Fraksiyonel CO2 lazer ve Pico lazer kombinasyon planları kişisel olarak değerlendirilir.",
        bullets: [
            "Aktif akne sonrası iz değerlendirmesi",
            "Cilt yüzeyi pürüzü için planlama",
            "Tedavi sonrası bakım önerileri",
        ],
        image: "skinTexture",
    },
    {
        slug: "ameliyat-izi-tedavisi",
        title: "Ameliyat / Travma İzi",
        short: "Ameliyat ve travma izi görünümünü azaltmaya yönelik plan.",
        icon: "Shield",
        keywords: "ameliyat izi tedavisi İstanbul",
        intro:
            "Ameliyat ve travma izlerinin görünümünün azaltılmasına yönelik lazer planları; izin yaşı, lokalizasyonu ve cilt tipi gibi faktörlere göre kişiye özel olarak belirlenir.",
        bullets: [
            "İz olgunlaşma evresine göre plan",
            "Kontrollü seans aralıkları",
            "Doku yenilenmesini destekleme yaklaşımı",
        ],
        image: "treatment2",
    },
    {
        slug: "esenyurt-dovme-silme",
        title: "Esenyurt Dövme Silme",
        short: "Esenyurt İstanbul'da Pico lazer dövme silme uygulamaları.",
        icon: "MapPin",
        keywords: "Esenyurt dövme silme",
        intro:
            "Esenyurt İstanbul lokasyonumuzda Pico lazer dövme silme ve Fraksiyonel CO2 lazer uygulamaları için kişisel ön değerlendirme imkânı sunulur.",
        bullets: [
            "Botanica İstanbul Sitesi içinde merkezi konum",
            "Esenyurt ve çevre ilçelere kolay ulaşım",
            "Randevulu kişisel değerlendirme",
        ],
        image: "clinicInterior",
    },
    {
        slug: "istanbul-dovme-silme",
        title: "İstanbul Dövme Silme",
        short: "İstanbul genelinde Pico lazer dövme silme değerlendirme süreci.",
        icon: "Building2",
        keywords: "İstanbul dövme silme, lazerle dövme silme İstanbul",
        intro:
            "İstanbul genelinden ulaşan ziyaretçilerimiz için Pico lazer dövme silme ve cover-up öncesi açtırma süreçlerinde kişisel değerlendirme planlanır.",
        bullets: [
            "Uzun mesafe ziyaretçileri için randevu planlaması",
            "Detaylı dövme/iz analizi",
            "Kişiye özel seans aralığı belirleme",
        ],
        image: "clinicInterior",
    },
    {
        slug: "dovme-silme-fiyatlari",
        title: "Dövme Silme Fiyatları",
        short: "Fiyatlandırma yaklaşımı ve değerlendirme süreci.",
        icon: "Receipt",
        keywords: "dövme silme fiyatları İstanbul",
        intro:
            "Net fiyat; dövme/iz boyutu, rengi, lokasyonu ve seans sayısına göre değerlendirme sonrası paylaşılır. Sağlıklı bir bilgi için fotoğraf ile ön değerlendirme önerilir.",
        bullets: [
            "Fotoğraf üzerinden ön bilgilendirme",
            "Seans paketleri için planlama",
            "Şeffaf süreç açıklaması",
        ],
        image: "metallic",
    },
];

export const SERVICE_TYPE_OPTIONS = SERVICES.filter((s) =>
    [
        "pico-lazer-dovme-silme",
        "cover-up-oncesi-dovme-actirma",
        "fraksiyonel-co2-lazer",
        "faca-izi-tedavisi",
        "yanik-izi-tedavisi",
        "akne-izi-tedavisi",
        "ameliyat-izi-tedavisi",
    ].includes(s.slug),
).map((s) => s.title);

export const FAQS = [
    {
        q: "Dövme tek seansta silinebilir mi?",
        a: "Hayır. Dövme silme süreci genellikle çok seanslı bir süreçtir. Net seans sayısı; cilt yapısı, dövme rengi, derinliği ve yaşı gibi faktörlere göre kişisel değerlendirme sonrası belirlenir. Sonuçlar kişiden kişiye değişebilir.",
    },
    {
        q: "Pico lazer her cilt tipi için uygun mudur?",
        a: "Uygunluk; cilt tipi, sağlık geçmişi ve dövme/iz analizi sonrası değerlendirilir. Kişisel ön değerlendirme yapılmadan kesin bir bilgi vermek doğru olmaz.",
    },
    {
        q: "Seanslar arasında ne kadar süre olmalı?",
        a: "Seans aralıkları genellikle 6-8 hafta olarak planlanır. Cilt iyileşme süreci ve değerlendirme sonucu bu süre değişebilir.",
    },
    {
        q: "Cover-up öncesi açtırma sürecinde tam silme gerekir mi?",
        a: "Cover-up öncesi açtırmada hedef genellikle tam silme değil, dövme tonunu açmaktır. Bu da seans sayısını çoğunlukla daha düşük tutar.",
    },
    {
        q: "Fraksiyonel CO2 lazer ile akne izi tamamen yok edilir mi?",
        a: "Tamamen yok etme garantisi vermek doğru olmaz. Fraksiyonel CO2 lazer, izin görünümünün azaltılmasına yönelik bir uygulamadır. Sonuçlar kişiden kişiye değişebilir.",
    },
    {
        q: "Süreç hakkında bilgi almak için ne yapmalıyım?",
        a: "WhatsApp üzerinden fotoğraf göndererek veya site üzerindeki ön değerlendirme formunu doldurarak kişisel değerlendirme için ulaşabilirsiniz.",
    },
];

export const PROCESS_STEPS = [
    {
        n: "01",
        title: "Ön Değerlendirme",
        text: "Fotoğraf veya yüz yüze görüşme ile dövme/iz analizi yapılır.",
    },
    {
        n: "02",
        title: "Kişisel Plan",
        text: "Cilt yapısı, dövme rengi ve derinliğine göre seans planı oluşturulur.",
    },
    {
        n: "03",
        title: "Seans Uygulaması",
        text: "Pico lazer veya Fraksiyonel CO2 ile uygulama, kontrollü parametrelerle yapılır.",
    },
    {
        n: "04",
        title: "Takip ve Bakım",
        text: "İyileşme süreci takibi ve bir sonraki seans planlaması paylaşılır.",
    },
];

export const TRUST_POINTS = [
    {
        title: "Kişisel Değerlendirme",
        text: "Her dövme ve iz farklıdır. Plan kişisel analiz sonrası belirlenir.",
    },
    {
        title: "Profesyonel Yaklaşım",
        text: "Doğuş Çizikoğlu eşliğinde dikkatli ve şeffaf süreç takibi.",
    },
    {
        title: "Modern Lazer Teknolojisi",
        text: "Pico lazer ve Fraksiyonel CO2 lazer parametre kontrollü uygulama.",
    },
    {
        title: "Şeffaf İletişim",
        text: "Garanti vaatlerinden uzak, gerçekçi süreç bilgilendirmesi.",
    },
];
